import { ItemID } from "types/common";

import { checkInformationKind } from "modules/MatchingModule/helpers/checkInformationKind";

import { BrandSourceKey, getBrandSource } from "../consts";

// The picked brand decides the tab; otherwise the only brand-bearing Information Type picked in Filters does
export const getDefaultBrandSourceKey = (
  brandId: ItemID,
  selectedInformationKinds?: string | string[] | null
): BrandSourceKey | undefined => {
  if (brandId) return getBrandSource(brandId)?.key;

  const { isMedicalProduct, isFoodProduct, isRetailProduct } = checkInformationKind(selectedInformationKinds);
  const picked: BrandSourceKey[] = [
    ...(isMedicalProduct ? ["medical" as const] : []),
    ...(isFoodProduct ? ["food" as const] : []),
    ...(isRetailProduct ? ["retail" as const] : []),
  ];
  return picked.length === 1 ? picked[0] : undefined;
};
